import { FirePerimeterAuto } from "./FirePerimeterAuto"

export const FirePerimeterPluginActionMethodAuto = () => {
    return <FirePerimeterAuto shouldShowConfirmControls />
}
